import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface State {
    createOpen: boolean;
    inProgress: boolean;
}

const initialState: State = {
    createOpen: false,
    inProgress: false,
};

const mailboxesSlice = createSlice({
    name: "mailboxes",
    initialState,
    reducers: {
        setCreateOpen: (state, action: PayloadAction<boolean>) => {
            state.createOpen = action.payload;
        },
        setInProgress: (state, action: PayloadAction<boolean>) => {
            state.inProgress = action.payload;
        },
    },
});

export const getCreateOpen = (state: { mailboxesReducer: State }): boolean => {
    return state.mailboxesReducer.createOpen;
};

export const getInProgress = (state: { mailboxesReducer: State }): boolean => {
    return state.mailboxesReducer.inProgress;
};

export const { setCreateOpen, setInProgress } = mailboxesSlice.actions;

export default mailboxesSlice.reducer;
